module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAA7UlEQVQ4jcWT0W3CMBCGv1a8txuUEboBYYNsQNQI+5URGCF9tCVLXYEJ2m4QNiAT0EwQZHRIh3HJQx74JUuny92f+3+fn4ZhYAqeJ3UDs1yyNnYLVMCbpHbAJnh3SGtvJNTGfgGrDG8PFMG7VievJNTGVknzL9BJ/AI0KWvqQaniZfCuAN6BveQWYwSvKj6PGrz7A37UlHPdkJrYqr80tbEbmaCSXJcamU7QiFmIF0fgW/Qz6oGw3xQJ9sG7URMjyVaZdkGvZNwnEJRKCrJEba4wSyBS4hVGfAbv4nLlETfxv/OxNsW97/E8+DUCJ7y2ccp/WSvJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/address.png
// module id = MO5Q
// module chunks = 1